var _path, _rect, _line, _line2, _rect2, _path2, _circle, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 43,
    viewBox: "0 0 52 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4861 1L7.55168 33.1639H29.5899L20.6555 1H16.4861Z",
    fill: "#E9FF70",
    stroke: "#0D3B70"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 33.1642,
    width: 35.142,
    height: 3.57376,
    fill: "#0D3B70",
    stroke: "#0D3B70"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5081,
    y1: 12.4128,
    x2: 23.6338,
    y2: 12.4128,
    stroke: "#0D3B70"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5299,
    y1: 22.5386,
    x2: 26.6118,
    y2: 22.5386,
    stroke: "#0D3B70"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4905,
    y: 37.9577,
    width: 3.31236,
    height: 3.30923,
    rx: 1.65462,
    transform: "rotate(-42.8489 21.4905 37.9577)",
    fill: "#E9FF70",
    stroke: "#0D3B70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0583 35.6803L22.7361 35.0705C20.6003 31.0281 22.146 26.0197 26.1884 23.884L30.0007 21.8699C30.5902 21.5584 31.3205 21.7838 31.6319 22.3733C31.9434 22.9628 32.6737 23.1882 33.2632 22.8767L34.1783 22.3933C34.7677 22.0818 34.9931 21.3515 34.6817 20.762C34.3703 20.1725 34.5957 19.4422 35.1851 19.1308L41.8037 15.634C42.7803 15.118 43.9903 15.4914 44.5063 16.468L46.3436 19.9456C46.8596 20.9223 46.4862 22.1323 45.5096 22.6483L41.4834 24.7754L39.9908 25.6674C39.1724 26.1564 38.6799 27.0476 38.7012 28.0008L38.7444 29.9285L38.7685 31.0015C38.787 31.8273 38.7459 32.6533 38.6457 33.4731C38.3724 35.7065 37.0234 37.6648 35.0339 38.7159L34.2448 39.1327C30.2024 41.2684 25.194 39.7227 23.0583 35.6803Z",
    fill: "#E9FF70",
    stroke: "#0D3B70"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2883,
    cy: 31.2752,
    r: 4.15648,
    transform: "rotate(-27.8489 30.2883 31.2752)",
    fill: "#0D3B70",
    stroke: "#E9FF70"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31.0227,
    y1: 18.5994,
    x2: 29.4114,
    y2: 15.5497,
    stroke: "#0D3B70"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33.1593,
    y1: 18.0843,
    x2: 34.5136,
    y2: 14.9121,
    stroke: "#0D3B70"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 29.9397,
    y1: 20.2161,
    x2: 26.5051,
    y2: 19.8991,
    stroke: "#0D3B70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/Clinic.9e9aceacbce6df850a8e5cb9332f64ac.svg";
export { ForwardRef as ReactComponent };